module.exports = __webpack_public_path__ + "static/media/Kevin.8f3604da.png";